import {AuthService} from './../services/auth';
import {PolicyPage} from './../pages/auth/policy/policy';
import {SessionService} from './../services/session';
import {Component, ViewChild} from '@angular/core';
import {Platform, NavController} from 'ionic-angular';
import {SignInPage} from '../pages/auth/sign-in/sign-in'
import {PlatformService} from './../services/platform';
import {StudiosService} from './../services/studios';
import {ClassesService} from './../services/classes';
import {MapService} from '../services/map';
import {AnalyticsService} from '../services/analytics';
import {TabsPage} from '../pages/tabs/tabs';
import {FirebaseService} from '../services/firebase';
import {BeautyStudiosService} from '../services/beauty-studios';
import {BeautyClassesService} from '../services/beauty-classes';
import { MishiService } from '../services/mishi';

@Component({
  templateUrl: 'app.html'
})
export class MyApp {
  signInPage = SignInPage;
  policyPage: any = PolicyPage;
  tabsPage = TabsPage;

  public rootPage;

  @ViewChild('nav') nav: NavController;

  constructor(platform: Platform,
              platformService: PlatformService,
              sessionService: SessionService,
              public studiosService: StudiosService,
              public beautyStudiosService: BeautyStudiosService,
              public classesService: ClassesService,
              public beautyClassesService: BeautyClassesService,
              public mapService: MapService,
              public analyticsService: AnalyticsService,
              public firebaseService: FirebaseService,
              public authService: AuthService,
  ) {
    //load user from device storage
    sessionService.load()
      .then(user => {
        if (user) {
          this.rootPage = this.tabsPage;
        } else {
          this.rootPage = this.signInPage;
        }
      })
      .catch(err => {
        sessionService.reportError('appComponent', 'constructor() sessionService.load()', err)
        this.rootPage = this.signInPage;
      })
    //load all cities
    this.mapService.getCities();
    //load all studios to display on the map
    this.studiosService.loadAll();
    this.beautyStudiosService.loadAll();
    //load all categories
    this.classesService.loadCategories();
    setInterval(() => {
      this.studiosService.loadAll()
    }, 15 * 60 * 1000)
    //initiate the classes to empty arrays
    this.classesService.initiateClasses();
    this.beautyClassesService.loadCategories()


    // platform.ready().then(() => {
    // initialize firebase so that IOS app know where to recieve Push messages from
    this.firebaseService.initializeFirebase();
    //Check current platform (IOS, Android, none)
    if (platform.is('android')) {
      platformService.platform = 'android';
    } else if (platform.is('ios')) {
      platformService.platform = 'ios';
      if (
        (platform.width() / platform.height()) === (375 / 812)
      ) {
        platformService.iphoneX = true;
      }
    }
    //gets your location
    this.mapService.getLocation()
      .then(() => {
        // gets the class list for the first 14 days
        this.classesService.loadAll(
          true,
          null,
          null,
          null,
          null,
          null,
          null,
          null,
          sessionService.user ? sessionService.user.city_id : null,
          null,
          null,
        )
      })
      .catch(err => {
        this.classesService.loadAll(
          true,
          null,
          null,
          null,
          null,
          null,
          null,
          null,
          sessionService.user ? sessionService.user.city_id : null,
          null,
          null,
        )

        sessionService.reportError('appComponent', 'constructor() mapService.getLocation()', err);
      });

    // //tracks user activity on page change
    // this.analyticsService.trackActivity();
    //
    // gets your unique device id
    this.analyticsService.getDeviceId();

    //pings the server for user status, and displays sign-in if "disabled"
    this.analyticsService.ping((user) => {
      if (user.disabled) {
        this.rootPage = this.signInPage;
      }
    });
    // });
  }

}



// WEBPACK FOOTER //
// ./src/app/app.component.ts